import * as Scrivito from "scrivito";

const TextImagePanelWidget = Scrivito.provideWidgetClass(
  "TextImagePanelWidget",
  {
    attributes: {
      headline: "string",
      description: "string",
      date: "string",
      content: "html",
      image: ["reference", { only: "Image" }],
      video: "string",
      videoObject: ["reference", { only: "Video" }],
      destination: "link",
    },
    extractTextAttributes: ["headline", "content", "description"],
  }
);

export default TextImagePanelWidget;
